import * as React from "react";
import { SVGProps } from "react";
const SvgLogoSmartsuite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 6.761h11.172c2.787 0 5.1 1.829 5.547 4.49L6.547 11.25C3.76 11.25 1.447 9.422 1 6.76Z"
      fill="#FF5757"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 18h11.172c2.787 0 5.1-1.823 5.547-4.484H6.547C3.76 13.517 1.447 15.34 1 18Z"
      fill="#3A86FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 4.498h11.172c2.787 0 5.1-1.838 5.547-4.498H6.547C3.76 0 1.447 1.837 1 4.498Z"
      fill="#FFB938"
    />
  </svg>
);
export default SvgLogoSmartsuite;
